import React from 'react';
import './App.css';
import StaceyPic from './no-image.jpg';
import pic1 from './About1.jpg';
import Topbar from './Topbar';
import Footer from './Footer';
import { motion } from 'framer-motion';
import { stacey1, stacey2, stacey3 } from './TextContent.json';
import { Link } from 'react-router-dom';

class Stacey extends React.Component {
    render() {
        return (
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >
                <Topbar />
                <div className="header-image5">
                    <div className="services1">Stacey Gudmundsson</div>
                </div>
                <div className='profile-container'>
                    <div className='profile-section'>
                        <img src={StaceyPic} alt="Stacey Gudmundsson" className='profile-pic' />
                        <div className='profile-overview-section'>
                            <div className='profile-header'>Overview</div>
                            <div className='profile-overview'>Populations Served</div>
                            <ul className='overview-list'>
                                <li>Children</li>
                                <li>Adolescents</li>
                                <li>Adults</li>
                            </ul>
                            <div className='profile-overview'>Therapy Formats</div>
                            <ul className='overview-list'>
                                <li>Individual</li>
                                <li>Family</li>
                                <li>Couples</li>
                            </ul>
                            <div className='profile-overview'>Main Areas of Focus</div>
                            <ul className='overview-list'>
                                <li>Complex Family Systems Issues</li>
                                <li>Life Transitions (incl. grief and loss)</li>
                                <li>Trauma</li>
                            </ul>
                        </div>
                    </div>
                    <br />
                    <div class="profile-bio">
                        <div>
                            <p className='profile-paragraph'>{stacey1}</p>
                            <p className='profile-paragraph'>{stacey2}</p>
                            <p className='profile-paragraph'>{stacey3}</p>
                            <p className='profile-paragraph'>**Stacey provides services <i>virtually</i></p>
                            <div class="services-button"><Link to='/contact' className="contact-submit contact-me">Interested in services? Click here</Link></div>
                        </div>
                        <img src={pic1} alt="image" className="image2 desktop" />
                    </div><br></br><br></br>
                </div>
                <Footer />
            </motion.div>
        )
    }
}

export default Stacey;